<div>{{ candidate.referenceNumber }}</div>
<div class="small"><strong>FILL:</strong> {{ candidate.fillNumber }}</div>
